/* tslint:disable */
/* eslint-disable */
/**
 * Stacks Blockchain API
 * Welcome to the API reference overview for the [Stacks Blockchain API](https://docs.hiro.so/stacks-blockchain-api).  [Download Postman collection](https://hirosystems.github.io/stacks-blockchain-api/collection.json) 
 *
 * The version of the OpenAPI document: STACKS_API_VERSION
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    OtherTransactionIdentifier,
    OtherTransactionIdentifierFromJSON,
    OtherTransactionIdentifierFromJSONTyped,
    OtherTransactionIdentifierToJSON,
    RosettaBlock,
    RosettaBlockFromJSON,
    RosettaBlockFromJSONTyped,
    RosettaBlockToJSON,
} from './';

/**
 * A BlockResponse includes a fully-populated block or a partially-populated block with a list of other transactions to fetch (other_transactions). As a result of the consensus algorithm of some blockchains, blocks can be omitted (i.e. certain block indexes can be skipped). If a query for one of these omitted indexes is made, the response should not include a Block object. It is VERY important to note that blocks MUST still form a canonical, connected chain of blocks where each block has a unique index. In other words, the PartialBlockIdentifier of a block after an omitted block should reference the last non-omitted block.
 * @export
 * @interface RosettaBlockResponse
 */
export interface RosettaBlockResponse {
    /**
     * 
     * @type {RosettaBlock}
     * @memberof RosettaBlockResponse
     */
    block?: RosettaBlock;
    /**
     * Some blockchains may require additional transactions to be fetched that weren't returned in the block response (ex: block only returns transaction hashes). For blockchains with a lot of transactions in each block, this can be very useful as consumers can concurrently fetch all transactions returned.
     * @type {Array<OtherTransactionIdentifier>}
     * @memberof RosettaBlockResponse
     */
    other_transactions?: Array<OtherTransactionIdentifier>;
}

export function RosettaBlockResponseFromJSON(json: any): RosettaBlockResponse {
    return RosettaBlockResponseFromJSONTyped(json, false);
}

export function RosettaBlockResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RosettaBlockResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'block': !exists(json, 'block') ? undefined : RosettaBlockFromJSON(json['block']),
        'other_transactions': !exists(json, 'other_transactions') ? undefined : ((json['other_transactions'] as Array<any>).map(OtherTransactionIdentifierFromJSON)),
    };
}

export function RosettaBlockResponseToJSON(value?: RosettaBlockResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'block': RosettaBlockToJSON(value.block),
        'other_transactions': value.other_transactions === undefined ? undefined : ((value.other_transactions as Array<any>).map(OtherTransactionIdentifierToJSON)),
    };
}

